import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, unref as _unref, createBlock as _createBlock, withDirectives as _withDirectives, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "toast-list__underlay"
};
const _hoisted_2 = { class: "toast-list" };
import { computed } from "vue";
import { vElementHover } from "@vueuse/components";
import ToastNotification from "../../modules/ToastNotification.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ToastContainer',
    props: {
        toastList: {
            type: Array,
            default: () => []
        }
    },
    emits: ["toast-hover", "toast-click", "primary-action", "secondary-action", "close-all", "close-toast"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emits = __emit;
        const isPermanent = computed(() => props.toastList.some((toast) => toast.options?.permanent));
        const listIsLong = computed(() => props.toastList.length > 3);
        const closeToast = (toast) => {
            emits("close-toast", toast);
        };
        const closeAllToast = () => {
            emits("close-all");
        };
        const toastHover = (hover) => {
            emits("toast-hover", hover);
        };
        const toastClick = (toast) => {
            if (isPermanent.value)
                return;
            emits("toast-click", toast);
        };
        const primaryAction = (toast) => {
            emits("primary-action", toast);
        };
        const secondaryAction = (toast) => {
            emits("secondary-action", toast);
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                (isPermanent.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1))
                    : _createCommentVNode("", true),
                _createElementVNode("section", _hoisted_2, [
                    _createVNode(_TransitionGroup, {
                        name: "toast-slide",
                        tag: "div",
                        "move-class": "toast-list__wrapper"
                    }, {
                        default: _withCtx(() => [
                            (listIsLong.value)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    class: "btn btn-xs btn-dark",
                                    onClick: closeAllToast
                                }, _toDisplayString(_ctx.$t("Clear all")), 1))
                                : _createCommentVNode("", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.toastList, (toast) => {
                                return _withDirectives((_openBlock(), _createBlock(ToastNotification, {
                                    key: toast.id,
                                    toast: toast,
                                    onClick: ($event) => (toastClick(toast)),
                                    onPrimaryAction: ($event) => (primaryAction(toast)),
                                    onSecondaryAction: ($event) => (secondaryAction(toast)),
                                    onCloseToast: ($event) => (closeToast(toast))
                                }, null, 8, ["toast", "onClick", "onPrimaryAction", "onSecondaryAction", "onCloseToast"])), [
                                    [_unref(vElementHover), toastHover]
                                ]);
                            }), 128))
                        ]),
                        _: 1
                    })
                ])
            ], 64));
        };
    }
});
